import request from "../request";

export function index(params) {
  return request({
    url: "/driver/client-payment",
    method: "get",
    params
  })
} 